import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import PhoneIcon from '@mui/icons-material/Phone'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import IntlMessages from '../../util/IntlMessages'
import { contactUs } from '../../constants/data'
import Header from '../../components/header'
import { telFormat } from '../../util'

export default function ContactUs() {
    return (
        <React.Fragment>
            <Header title={<IntlMessages id="contact-us" />} />
            <List dense={false}>
                <ListItem
                    secondaryAction={
                        <IconButton edge="end">
                            <MailOutlineIcon />
                        </IconButton>
                    }
                >
                    <ListItemText
                        primary={contactUs.email}
                    />
                </ListItem>
                <ListItem
                    onClick={() => window.location.href = telFormat(contactUs.mobile)}
                    secondaryAction={
                        <IconButton edge="end">
                            <PhoneIcon />
                        </IconButton>
                    }
                >
                    <ListItemText

                        primary={contactUs.mobile}
                    />
                </ListItem>
            </List>
        </React.Fragment>
    )
}
